import {
    apiRequest,
    HDlistHistory,
} from "../../../../../services/adapters/kepegawaian/hukumanDisiplinService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", HDlistHistory, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository